export enum ViewType {
    View = 'View',
    HttpCall = 'Http',
    File = 'File',
    Logic = 'Logic',
    Embed = 'Embed',
    Error = 'Error',
}
